import { Filter, FilterType } from '@dfl/mui-admin-layout';
import { OFFER_TYPE } from './offer.type.enum';
import { discountTypeFilter, discountValueFilter } from 'modules/sales-offer/product-discount/constants';

export const fromDateFilter: Filter = {
  filter: 'offerOrder:fields.fromDate',
  translate: true,
  type: FilterType.DATE,
  key: 'fromDate',
  field: 'fromDate',
};

export const toDateFilter: Filter = {
  filter: 'offerOrder:fields.toDate',
  translate: true,
  type: FilterType.DATE,
  key: 'toDate',
  field: 'toDate',
};

export const typeFilter: Filter = {
  filter: 'offerOrder:offerType',
  type: FilterType.FIXED_LIST,
  translate: true,
  key: 'type',
  field: 'type',

  options: Object.keys(OFFER_TYPE)
    ?.filter((key) => ![OFFER_TYPE.INCLUDE_PRODUCT, OFFER_TYPE.TWO_FOR_ONE].includes(key as OFFER_TYPE))
    .map((key) => ({
      value: OFFER_TYPE[key as OFFER_TYPE],
      translate: true,
      label: `offerOrder:types.${key}`,
    })),
};

export const offerFilters = [
  typeFilter,
  discountValueFilter('discountValue.value'),
  discountTypeFilter('discountValue.type'),
  fromDateFilter,
  toDateFilter,
];
